var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonActionModal',{attrs:{"dialog":_vm.dialogLeadEncontrado,"title":_vm.title,"subtitle":_vm.subtitle,"bottonText":"Si, abrir"},on:{"userChoice":_vm.changeRoute}})}
var staticRenderFns = []

export { render, staticRenderFns }